export function getdata() {
	var obj = {
		searchlist: [{
				prop: "ruleNum",
				label: '映射规则编码',
				type: "input",
			},
			{
				prop: "defaultFlag",
				label: '是否默认',
				type: "select",
				selectval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "0"
					}
				]
			},
			{
				prop: "companyNames",
				label: '相关公司',
				type: "input",
			},
			{
				prop: "description",
				label: '说明',
				type: "input"
			},
		],
		searchdata: {
			ruleNum: "",
			defaultFlag: "",
			companyNames: "",
			description: "",
			ids: "",
		},
		formlist: [{
			prop: "ruleNum",
			label: "映射规则编码",
			type: "input",
			width: "220px",
			isnotnull: true,
			Customtips: '0-30位编码，编码不能有空格。',
			Customrules: /^[^\u9fa5 ]{0,30}$/,

		}, {
			prop: "defaultFlag",
			label: "是否默认",
			type: "radio",
			radioval: [{
					label: '是',
					value: '1'
				},
				{
					label: '否',
					value: '0'
				},
			],
			isnotnull: true
		}, {
			prop: "description",
			label: "说明",
			type: "textarea",
			width: "380px",
			isnotnull: true
		}],
		formdata: {
			ruleNum: "",
			defaultFlag: "",
			description: ""
		},
		headData: [{
				title: "映射规则编码",
				prop: "ruleNum",
				custom: true,
				issort: true,
				width: 140
			},
			{
				title: "是否默认",
				prop: "defaultFlag",
				custom: true,
				issort: true,
				width: 100
			},
			{
				title: "相关公司",
				prop: "companyNames",
				custom: true,
				issort: true,
				width: 160,
			},
			{
				title: "说明",
				prop: "description",
				custom: true,
				issort: true,
				width: 160,
			},
			{
				title: "操作",
				prop: "cz",
				width: 300,
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationcompany: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatacompany: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80
			},
			{
				title: "公司名称",
				prop: "nsrmc",
				width: 160,
				align: "left"
			},
		],
		headDataAdd: [{
				title: "公司代码",
				prop: "companyCode",
			},
			{
				title: "公司名称",
				prop: "nsrmc",
			}, {
				title: "纳税人识别号",
				prop: "nsrsbh",
			}
		],
	}
	return obj
}
